/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wakil_TInputs */

const en_tut_wakil_t = /** @type {(inputs: Tut_Wakil_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Digital Deputy: who answers when you are away`)
};

const id_tut_wakil_t = /** @type {(inputs: Tut_Wakil_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wakil Digital: yang menjawab saat Anda tidak ada`)
};

/**
* | output |
* | --- |
* | "The Digital Deputy: who answers when you are away" |
*
* @param {Tut_Wakil_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wakil_t = /** @type {((inputs?: Tut_Wakil_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wakil_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wakil_t(inputs)
	return en_tut_wakil_t(inputs)
});